import React from 'react'

export const DetailBrand = () => {
  return (
    <div>Detail</div>
  )
}
